"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LazyRoute = exports.renderLazyRoute = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var Loader_1 = require("../../ui/loader/Loader");
var UI_1 = require("../../ui/UI");
function renderLazyRoute(_a) {
    var layout = _a.layout, component = _a.component, render = _a.render;
    var useLayout = UI_1.useUIContext().useLayout;
    return function (props) {
        var rendered;
        if (component) {
            var Component = Loader_1.lazyLoad(component);
            rendered = react_1.default.createElement(Component, tslib_1.__assign({}, props));
        }
        else if (render) {
            rendered = render(props);
        }
        if (!layout) {
            return react_1.default.createElement(react_1.default.Fragment, null, rendered);
        }
        return useLayout(tslib_1.__assign({ children: rendered }, layout));
    };
}
exports.renderLazyRoute = renderLazyRoute;
function LazyRoute(_a) {
    var component = _a.component, render = _a.render, layout = _a.layout, routeProps = tslib_1.__rest(_a, ["component", "render", "layout"]);
    return (react_1.default.createElement(react_router_dom_1.Route, tslib_1.__assign({}, routeProps, { render: renderLazyRoute({
            layout: layout,
            component: component,
            render: render,
        }) })));
}
exports.LazyRoute = LazyRoute;
//# sourceMappingURL=LazyRoute.js.map